<app-item [detailIcon]="false">
    <div class="skeleton-container">
        <ion-skeleton-text class="icon-skeleton" animated></ion-skeleton-text>
        <div class="text-container">
            <ion-skeleton-text class="title-skeleton" animated></ion-skeleton-text>
            <ion-skeleton-text class="subtitle-skeleton" animated></ion-skeleton-text>
        </div>
    </div>
</app-item>
